import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {InsuranceCompany} from '../../../../shared/interface/insurance-company';
import {ReplaySubject} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {FormHelperService} from '../../../../shared/services/form-helper.service';
import {DictService} from '../../../../shared/services/dict.service';
import {first} from 'rxjs/operators';
import {Uuid} from '../../../../shared/interface/response/uuid';
import {HttpErrorResponse} from '@angular/common/http';
import {ThresholdService} from '../../../../shared/services/threshold.service';

@Component({
  selector: 'app-add-threshold',
  templateUrl: './add-threshold.component.html',
  styleUrls: ['./add-threshold.component.scss']
})
export class AddThresholdComponent implements OnInit, OnDestroy {
  thresholdDictionaryForm: FormGroup;
  insuranceCompanyControl: FormControl;
  importerControl: FormControl;
  policyTypesControl: FormControl;
  nameControl: FormControl;
  processingRequest = false;
  errors: any = {};
  selectedInsuranceCompany: InsuranceCompany;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private dictService: DictService,
    private thresholdService: ThresholdService,
  ) {
    this.thresholdDictionaryForm = this.fb.group({
      name: this.nameControl = fb.control('', [Validators.required]),
      insuranceCompany: this.insuranceCompanyControl = fb.control('', [Validators.required]),
      importer: this.importerControl = fb.control(''),
      policyTypes: this.policyTypesControl = fb.control([]),
    });
  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  save(): void {
    this.processingRequest = true;
    this.thresholdService.sendForm(
      this.thresholdDictionaryForm.value,
    )
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snackBar.open('Pomyślnie utworzono próg', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.router.navigate(['/progi', {uuid: response.uuid}]);
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.errors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.thresholdDictionaryForm, this.errors);
        }
      });
  }

  cancel(): void {
    this.router.navigate(['/progi']);
  }

  insuranceCompanyChanged(insuranceCompany: InsuranceCompany): void {
    this.selectedInsuranceCompany = insuranceCompany;
  }
}
